module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAT4BAMAAAAr6bV4AAAAJFBMVEXl9//9/v/r+f/o+f/4/f/t+v/W8//0/P/b9P/i9v/w+//e9f83gX19AAAAnElEQVRIx+2TgQmEMAxFO8KNcCNkhBshI9wIN4Ij3AiO4IhKJHz4mgpaoqB5/P7+plAobfleis7d1JFnMUzYGHgr/hM2kgPktpRZhpX58RJ3kyAztMa84UsBytsoJeU+NENZd0nj89BZO2cThQdIvUN3DkkjiimYI1Fhr+d7lQRrVeWA17MDpXn4t5rRp/JzT+QDr+tEXpzdH3IZAVi9MnDMNokHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/v2-bg1-right.png
// module id = 557
// module chunks = 0